/* Shaped like a quiet search field: a soft blue-grey fill, a hairline, the text in graphite.
   It fills its slot (the top of the sidebar, or the header). */
.trigger {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
  min-width: 12rem;
  height: var(--control-height);
  padding: 0 var(--space-2) 0 var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--wash);
  color: var(--graphite);
  font: var(--t-body);
  text-align: left;
  cursor: text;
  transition:
    border-color var(--dur) var(--ease),
    background-color var(--dur) var(--ease);
}

.trigger[data-hovered] {
  border-color: var(--border-strong);
  background: var(--paper);
}

.trigger[data-pressed] {
  background: var(--brand-tint);
}

.trigger[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

/* A small magnifier drawn with borders, so no icon font is needed. */
.lens {
  position: relative;
  flex: none;
  width: 12px;
  height: 12px;
  margin-right: 2px;
  border: 2px solid currentcolor;
  border-radius: 50%;
}

.lens::after {
  position: absolute;
  right: -5px;
  bottom: -4px;
  width: 6px;
  border-top: 2px solid currentcolor;
  content: '';
  transform: rotate(45deg);
}

.label,
.shortLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shortLabel {
  display: none;
}

.keys {
  flex: none;
}

/* Phones: a compact "Search" button; the key hint is no use without a keyboard. */
@media (width < 640px) {
  .trigger {
    width: auto;
    min-width: var(--touch-target);
    padding-right: var(--space-3);
  }

  .label[data-has-short] {
    display: none;
  }

  .shortLabel {
    display: block;
  }

  .keys {
    display: none;
  }
}
